import { render, staticRenderFns } from "./NursingCareLeaveInput.vue?vue&type=template&id=3c2f0e71&"
import script from "./NursingCareLeaveInput.vue?vue&type=script&lang=js&"
export * from "./NursingCareLeaveInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports